import { FormattedMessage } from 'react-intl'

import { DescriptionItem } from './description-item'

export const RoomTransferDescription = () => {
  return (
    <div className="flex flex-col gap-[14px]">
      <DescriptionItem
        color="action.active"
        text={<FormattedMessage id="edge.premiumRedeem.confirmRoomTransfer.description.1" />}
      />
      <DescriptionItem
        color="warning.main"
        text={<FormattedMessage id="edge.premiumRedeem.confirmRoomTransfer.description.2" />}
      />
    </div>
  )
}
